<template>
    <div class="main">
        <div class="main_tabs">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="库存管理" name="first">
                    <embedded-invent ref="Invent"></embedded-invent>
                </el-tab-pane>
                <el-tab-pane label="消耗记录" name="third">
                    <embedded-cost ref="Costs"></embedded-cost>
                </el-tab-pane>
                <el-tab-pane label="入库记录" name="second">
                    <embedded-income ref="Income"></embedded-income>
                </el-tab-pane>
                <el-tab-pane label="校正记录" name="fourth">
                    <embedded-check ref="checks"></embedded-check>
                </el-tab-pane>
                <el-tab-pane label="预埋件种类" name="five">
                    <embedded-type ref="Auxiliary"></embedded-type>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import EmbeddedInvent from './components/embedded/Invent'//库存管理
import EmbeddedCost from './components/embedded/Cost'//消耗记录
import EmbeddedIncome from './components/embedded/Income'//入库记录
import EmbeddedCheck from './components/embedded/Check'//校正记录
import EmbeddedType from './components/embedded/Type'//预埋件种类
export default {
    components: {
        EmbeddedInvent,
        EmbeddedCost,
        EmbeddedIncome,
        EmbeddedCheck,
        EmbeddedType
    },
    data() {
        return {
            activeName: 'first'
        }
    },
    mounted() {
        this.$refs.Invent.searchButtonInfo(true);
    },
    methods: {
        //切换界面
        handleClick(tab) {
            switch (tab.name) {
                case 'second':
                    this.$refs.Income.searchButtonInfo(true);
                    this.$refs.Income.getNameList()
                    break;
                case 'third':
                    this.$refs.Costs.searchButtonInfo(true);
                    this.$refs.Costs.getNameList()
                    break;
                case 'fourth':
                    this.$refs.checks.searchButtonInfo(true);
                    break;
                case 'five':
                    this.$refs.Auxiliary.searchButtonInfo(true);
                    this.$refs.Auxiliary.getAllTypes();
                    break;
                default:
                    this.$refs.Invent.searchButtonInfo(true);
            }
        },
    }
}
</script>
<style scoped lang="scss">
@import'@/style/layout-main.scss';

/deep/ .el-tabs__content {
    position: static;
}

/deep/.main {
    background: none;
}
</style>